<!--
 * @Author: Narcissus
 * @Date: 2022-12-05 11:08:59
 * @LastEditTime: 2022-12-05 12:01:28
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \analysis_chemical_shift_table\ui\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
div,
span,
p,
input {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue